export default __webpack_public_path__ + "e713f1f99ea3b381b3d454f1fbe4b567.woff";